























































































import { Vue, Component } from 'vue-property-decorator'
import { resumoDePedidos, ResumoDePedidos } from '@/api/pedido'
import { primaryColor } from '@/plugins/vuetify'
import axios, { CancelTokenSource } from 'axios'

const STATUS: Record<string, { label: string; cor: string }> = {
	PENDENTE: { label: 'Pendente', cor: '#E8A55C' },
	EM_SEPARACAO: { label: 'Em Separação', cor: '#6BA3D6' },
	AGUARDANDO_COLETA: { label: 'Aguardando Coleta', cor: '#6BA3D6' },
	COLETADO: { label: 'Coletado', cor: '#6BA3D6' },
	FATURADO: { label: 'Faturado', cor: '#5FA69B' },
	DESPACHADO: { label: 'Despachado', cor: '#7B85C4' },
	ENTREGUE: { label: 'Entregue', cor: '#7BB58A' },
	EM_OCORRENCIA: { label: 'Em Ocorrência', cor: '#D98A88' },
	AUSENTE: { label: 'Ausente', cor: '#D98A88' },
	DEVOLVIDO: { label: 'Devolvido', cor: '#B084C4' },
	CANCELADO: { label: 'Cancelado', cor: '#A0A0A0' },
	RECEBIDO: { label: 'Pedido Recebido de Devolução', cor: '#B084C4' },
	PEDIDO_PRONTO_PARA_RETIRADA_NA_lOJA: { label: 'Pedido pronto para Retirada na Loja', cor: '#6BA3D6' },
}
const PALETA = ['#CECBF6', '#AFA9EC', '#7F77DD', '#534AB7', '#3C3489']

const LS_KEY = 'pedidos-dash-aberta'

@Component
export default class MiniDashDePedidos extends Vue {
	resumo: ResumoDePedidos | null = null
	mapa: any = null
	cancelToken: CancelTokenSource | null = null
	aberta: boolean = localStorage.getItem(LS_KEY) !== 'false'

	toggleAberta() {
		this.aberta = !this.aberta
		localStorage.setItem(LS_KEY, String(this.aberta))
	}

	async carregar(params: { lojaId?: string; dataInicial?: string; dataFinal?: string }) {
		try {
			if (this.cancelToken) this.cancelToken.cancel()
			this.cancelToken = axios.CancelToken.source()
			this.resumo = await resumoDePedidos(params, { cancelToken: this.cancelToken.token })
			if (!this.mapa) {
				const m = await import('@/shareds/mapa/brasil-uf.json')
				this.mapa = (m as any).default || m
			}
		} catch (error: any) {
			if (axios.isCancel(error)) return
			this.resumo = null
		}
	}

	cont(...nomes: string[]): number {
		if (!this.resumo) return 0
		return this.resumo.porStatus
			.filter(s => nomes.includes(s.chave))
			.reduce((acc, s) => acc + s.quantidade, 0)
	}

	get cards() {
		return [
			{ titulo: 'Pendentes', valor: this.cont('PENDENTE'), cor: '#E8A55C', corFundo: 'amber lighten-5', corIcone: 'amber darken-1', icone: 'mdi-clock-alert-outline', situacoes: ['Pendente'] },
			{ titulo: 'Em preparo', valor: this.cont('EM_SEPARACAO', 'AGUARDANDO_COLETA', 'COLETADO'), cor: '#6BA3D6', corFundo: 'blue lighten-5', corIcone: 'blue lighten-1', icone: 'mdi-package-variant', situacoes: ['Em Separação', 'Aguardando Coleta', 'Coletado'] },
			{ titulo: 'Em trânsito', valor: this.cont('DESPACHADO'), cor: '#7B85C4', corFundo: 'indigo lighten-5', corIcone: 'indigo lighten-1', icone: 'mdi-truck-fast-outline', situacoes: ['Despachado'] },
			{ titulo: 'Ocorrências', valor: this.cont('EM_OCORRENCIA', 'AUSENTE'), cor: '#D98A88', corFundo: 'red lighten-5', corIcone: 'red lighten-1', icone: 'mdi-alert-circle-outline', situacoes: ['Em Ocorrência', 'Ausente'] },
			{ titulo: 'Entregues', valor: this.cont('ENTREGUE'), cor: '#7BB58A', corFundo: 'green lighten-5', corIcone: 'green lighten-1', icone: 'mdi-check-circle-outline', situacoes: ['Entregue'] },
		]
	}

	get funil() {
		const ordem = ['PENDENTE', 'EM_SEPARACAO', 'AGUARDANDO_COLETA', 'COLETADO', 'FATURADO', 'DESPACHADO', 'ENTREGUE']
		return ordem.map(n => ({ nome: n, label: STATUS[n].label, cor: STATUS[n].cor, qtd: this.cont(n) }))
	}

	get excecoes() {
		const ex = ['EM_OCORRENCIA', 'AUSENTE', 'DEVOLVIDO', 'CANCELADO', 'RECEBIDO', 'PEDIDO_PRONTO_PARA_RETIRADA_NA_lOJA']
		return ex.map(n => ({ label: STATUS[n].label, cor: STATUS[n].cor, qtd: this.cont(n) })).filter(e => e.qtd > 0)
	}

	get maxFunil(): number {
		return Math.max(1, ...this.funil.map(f => f.qtd))
	}
	barra(qtd: number): number {
		return Math.round((qtd / this.maxFunil) * 100)
	}

	get ufCount(): Record<string, number> {
		const m: Record<string, number> = {}
		if (this.resumo) this.resumo.porUf.forEach(u => { m[u.chave] = u.quantidade })
		return m
	}
	get maxUf(): number {
		return Math.max(1, ...Object.values(this.ufCount))
	}
	get topUf() {
		return Object.entries(this.ufCount)
			.map(([uf, qtd]) => ({ uf, qtd }))
			.sort((a, b) => b.qtd - a.qtd)
			.slice(0, 6)
	}
	barraUf(qtd: number): number {
		return Math.round((qtd / this.maxUf) * 100)
	}
	corUf(qtd: number): string {
		if (!qtd) return this.$vuetify.theme.dark ? 'rgba(255,255,255,.08)' : '#ECEBF2'
		const i = Math.min(PALETA.length - 1, Math.floor((qtd / this.maxUf) * PALETA.length))
		return PALETA[i]
	}

	filtrarPorStatus(situacoes: string[]) {
		this.$emit('filtrar-status', situacoes)
	}

	corPrimaria = primaryColor()
}
